import React from "react";
import StatusModal from "../common/ChangeStatusModal";
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "../redux/features/modalSlice";
import "../GlobalModel.css";
import DeleteModal from "../common/DeleteModal";
import ToggleChangeStatusModal from "../common/ToggleStatusModal";
import AddRemark from "../Pages/Remark/AddRemark";
import AddStaff from "../Pages/Staff Managment/AddStaff";
import UpdateRemark from "../Pages/Remark/updateRemark";
import EditCity from "../Pages/Staff Managment/EditStaff";
import ViewCity from "../Pages/Staff Managment/ViewStaff";
import ViewEnquiry from "../Pages/Lead Managment/EnquiryManagment/ViewEnquiry";
import EditEnquiry from "../Pages/Lead Managment/EnquiryManagment/EditEnquiry";
import AddRole from "../Pages/RoleManagment/AddRole";
import ViewRole from "../Pages/RoleManagment/ViewRole";
import UpdateRole from "../Pages/RoleManagment/EditRole";
import ViewBlog from "../Pages/Blog/ViewBlog";
import EditBlog from "../Pages/Blog/UpdateBlog";
import ViewTestimonial from "../Pages/Testimonials/ViewTestimonials";
import EditTestimonial from "../Pages/Testimonials/UpdateTestimonials";
import UploadPreviewModal from "../Pages/Lead Managment/UploadCSV";
import UpdateStatusModal from "../common/ChangeStatusModal";
import AssignLeadsModal from "../common/StaffSelectionModel";
import ViewDepartment from "../Pages/DepartmetnManagment/ViewDepartment";
import AddDepartment from "../Pages/DepartmetnManagment/AddDepartment";
import EditDepartment from "../Pages/DepartmetnManagment/EditDepartment";
import ChangePasswordModel from "../common/ChangePasswordModel";
import ChangeStaffPasswordModel from "../common/ChangeStaffPasswordModel";
import AddReminder from "../Pages/Reminder/Reminder";
import KycStatusConfirmModal from "../common/KycStatusConfirmModal";
import KycRemark from "../Pages/Remark/KycRemark";
import EnquiryRemark from "../Pages/Remark/EnquiryRemark"
import EditSubscription from "../Pages/Remark/EnquiryRemark"
import ViewSubscription from "../Pages/subscription Managment/ViewPlan"
import ViewNotification from "../Pages/Notification Managment/ViewNotification"
import AddSubscription from "../Pages/subscription Managment/AddPlan"
import RenewSubscription from "../Pages/subscription Managment/RenewPlan";
import UpgradeSubscription from "../Pages/subscription Managment/UpgradePlan";
import AddCustomPlan from "../Pages/subscription Managment/AddCustomPlan";
const GlobalModal = () => {
  const dispatch = useDispatch();
  const modalState = useSelector(
    (state) => state.modal
  );
  const {
    isOpen,
    type,
    data,
    title,
  } = modalState;

  if (!isOpen) return null;

  const renderContent = () => {
    switch (type) {

      case "add-staff":
        return (
          <AddStaff data={data} isModal={true} />
        );
      case "view-city":
        return (
          <ViewCity data={data} />
        );

      case "edit-city":
        return (
          <EditCity data={data} />
        );
         case "add-subscription":
        return (
          <AddSubscription data={data} isModal={true} />
        );
      case "view-subscription":
        return (
          <ViewSubscription data={data} />
        );

      case "edit-subscription":
        return (
          <EditSubscription data={data} />
        );

      case "upgrade-subscription":
        return (
          <UpgradeSubscription data={data}
           onSuccess={data?.onSuccess}  />
        );
      case "renew-subscription":
        return (
          <RenewSubscription data={data}
           onSuccess={data?.onSuccess}  />
        );




      case "kyc-status-confirm":
        return (
          <KycStatusConfirmModal
            data={data}
            title={title}
          />
        );
      case "enduiry-status-remark":
        return <EnquiryRemark data={data} />;
      case "kyc-add-remark":
        return (
          <KycRemark data={data} />
        );

      case "add-role":
        return <AddRole />;
      case "delete-city":
        return (
          <DeleteModal
            title="Delete City?"
            message={`You are deleting ${data?.city}`}
            deleteFunction={data?.deleteFunction}
            id={data?._id}
          />
        );
   case "delete-enquiry":
  return (
    <DeleteModal
      title="Delete Enquiry?"
      message={`You are deleting "${data?.name || "this enquiry"}"`}
      id={data?.id}     
        type={data?.type}                      
      deleteFunction={data?.deleteFunction}
      onSuccess={data?.refreshData} 
    />
  );
      case "delete-role":
        return (
          <DeleteModal
            title="Delete Role?"
            message={`You are deleting ${data?.name}`}
            id={data?._id}
            deleteFunction={data?.deleteFunction}
          />
        );
      case "delete-notification":
        return (
          <DeleteModal
            title="Delete Notification ?"
            message={`You are deleting ${data?.name}`}
            id={data?._id}
            deleteFunction={data?.deleteFunction}
          />
        );
      case "delete-plan":
        return (
          <DeleteModal
            title="Delete Plan?"
            message={`You are deleting ${data?.name}`}
           id={data?.id || data?._id} 
            deleteFunction={data?.deleteFunction}
          />
        );

      case "import-lead":
        return <UploadPreviewModal />;


      case "assign-leads":
        return (
          <AssignLeadsModal
            data={data}
          />
        );
      case "change-password":
        return (
          <ChangePasswordModel
            data={data}
          />
        );
      case "staff-change-password":
        return (
          <ChangeStaffPasswordModel
            data={data}
          />
        );

      case "delete-staff":
        return (
          <DeleteModal
            title="Delete Staff?"
            message="Are you sure you want to delete this staff member?"
            id={data?.id}
            deleteFunction={data?.deleteFunction}
            onSuccess={data?.refreshData}
          />
        );



      case "change-toggle-status":
        return (
          <ToggleChangeStatusModal
            title={title}
            message="Are you sure you want to change status?"
            id={data?.id}
            currentStatus={data?.status}
            statusFunction={data?.statusFunction}
            onSuccess={data?.onSuccess}
          />
        );


      case "delete-state":
        return (
          <DeleteModal
            title="Delete State?"
            message={`You are deleting ${data?.name}`}
            deleteFunction={data?.deleteFunction}
            id={data?._id}
          />
        );

      case "update-status":
        return (
          <UpdateStatusModal
            title={title}
            id={data?.id}
            currentStatus={data?.status}
            statusFunction={data?.statusFunction}
            statusOptions={data?.statusOptions || []}
            onSubmit={data?.onSubmit}
            role={data?.role}
          />
        );
      case "delete-lead":
        return (
          <DeleteModal
            title="Delete Lead?"
            message="Are you sure you want to delete this lead?"
            id={data?.id}
            deleteFunction={data?.deleteFunction}
            onSuccess={data?.refreshData}
          />
        );

      case "view-department":
        return <ViewDepartment data={data} />;

      case "edit-department":
        return <EditDepartment data={data} />;

      case "add-department":
        return <AddDepartment data={data} />;


      case "view-role":
        return (
          <ViewRole data={data} />
        );
      case "view-notification":
        return (
          <ViewNotification data={data} />
        );

      case "edit-role":
        return (
          <UpdateRole data={data} />
        );
      case "delete-department":
        return (
          <DeleteModal
            title="Delete Department?"
            message={`You are deleting ${data?.name}`}
            deleteFunction={data?.deleteFunction}
            id={data?._id}
            onSuccess={data?.refreshData}
          />
        );
      case "parmanent-delete-user":
        return (
          <DeleteModal
            title="Delete Vendor?"
            message={`You are deleting ${data?.name}`}
            deleteFunction={data?.deleteFunction}
            id={data?._id}
            onSuccess={data?.refreshData}
          />
        );
     
     
     
     
        case "add-remark":
        return (
          <AddRemark data={data} />
        );
      case "add-reminder":
        return (
          <AddReminder data={data} />
        );
      case "update-remark":
        return (
          <UpdateRemark data={data} />
        );

      case "view-testimonial":
        return (
          <ViewTestimonial data={data} />
        );

      // case "view-enquiry":
      //   return (
      //     <ViewEnquiry data={data} />
      //   );

      case "view-enquiry":
        return <ViewEnquiry data={data} />;

      case "edit-enquiry":
        return <EditEnquiry data={data} isVendor={false} />;

      case "edit-vendor-enquiry":
        return <EditEnquiry data={data} isVendor={true} />;

      case "edit-testimonial":
        return (
          <EditTestimonial data={data} />
        );


  case "add-custom-plan":
  return <AddCustomPlan data={data}  />;

      case "delete-testimonial":
        return (
          <DeleteModal
            title="Delete Testimonial?"
            message={`You are deleting ${data?.name}`}
            deleteFunction={data?.deleteFunction}
            id={data?._id}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="modal-overlay">

      <div className="modal-box">

        {/* HEADER */}
        <div className="modal-header">

          <h2 className="heading">
            {title}
          </h2>

          <button
            className="close-btn"
            onClick={() =>
              dispatch(closeModal())
            }
          >
            ✕
          </button>

        </div>

        {/* CONTENT */}
        <div className="modal-content">
          {renderContent()}
        </div>

      </div>

    </div>
  );
};

export default GlobalModal;